
import BaseSubNav from '@/components/base/BaseSubNav'
import {Component} from 'vue-property-decorator'

@Component
export default class BaseSubNavContainer extends BaseSubNav {}
